<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer006">
<p class="book-pages---regular"><span class="charoverride"><br class="calibre1"/></span></p>
<h1 class="book-pages---regular"><span class="charoverride">Epigraph</span></h1>
<p class="basic-paragraph1"><span class="charoverride1"><br class="calibre1"/></span></p>
<p class="basic-paragraph1"><span class="charoverride1">Revenge is a kind of wild justice;<br class="calibre2"/>which the more man’s nature runs to,<br class="calibre2"/>the more ought law to weed it out.</span></p>
<p class="basic-paragraph2"><span class="charoverride2">Francis Bacon, 1st Baron Verulam<br class="calibre2"/>‘On Revenge’</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?0bad3af9